<script lang="ts">
  // Draws the parsed card, one allowed tag at a time, recursing into itself.
  //
  // This is why there is no frame and no raw-HTML injection anywhere in the app: a
  // native control has to sit inside a table cell, and a cell we did not build is a cell
  // we cannot put anything into. Building the tree ourselves is the cheaper safety
  // property as well — the delivered markup is never markup again after it is parsed.

  import type { CardNode } from '$lib/protocol/sanitize-html';
  import type { CardControl } from '$lib/protocol/types';

  import type { ElementContext } from './context';
  import type { CardState } from './controls/card-state.svelte';
  import ControlView from './controls/ControlView.svelte';
  import Self from './CardNodes.svelte';

  let {
    nodes,
    controls,
    ctx,
    card,
  }: {
    nodes: CardNode[];
    controls: CardControl[];
    ctx: ElementContext;
    card: CardState;
  } = $props();
</script>

{#each nodes as node, i (i)}
  {#if node.kind === 'text'}
    {node.text}
  {:else if node.kind === 'slot'}
    <ControlView control={controls[node.index]} {ctx} {card} />
  {:else if node.tag === 'br' || node.tag === 'hr'}
    <svelte:element this={node.tag} />
  {:else if node.tag === 'td' || node.tag === 'th'}
    <svelte:element this={node.tag} colspan={node.colspan} rowspan={node.rowspan}>
      <Self nodes={node.children} {controls} {ctx} {card} />
    </svelte:element>
  {:else}
    <svelte:element this={node.tag}>
      <Self nodes={node.children} {controls} {ctx} {card} />
    </svelte:element>
  {/if}
{/each}
